
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

import { sharedState } from '../state';
import {
    dateAndTimeToDbDateTimeString,
    dateToDbDateString,
    dateToUiDateTimeString,
} from '../../../common/framework/util/convert';
import { getFieldNameFromVModelProperty } from '../util/component_util';

@Component({
    components: { ValidationProvider },
})
export default class DateTimeField extends Vue {
    @Prop(String) readonly name!: string;
    @Prop(String) readonly value!: string;
    @Prop(Boolean) readonly readonly!: string;
    @Prop(Boolean) readonly required!: boolean;
    @Prop(Boolean) readonly horizontal!: boolean;
    @Prop(Boolean) readonly disabled!: string;

    shared = sharedState;
    local = {
        value: undefined as Date | undefined,
        date: undefined as Date | undefined,
        time: undefined as Date | undefined,
        dayNames: [] as string[],
        monthNames: [] as string[],
    };

    async mounted() {
        this.local.monthNames = [
            this.$t('enum.month.january').toString(),
            this.$t('enum.month.february').toString(),
            this.$t('enum.month.march').toString(),
            this.$t('enum.month.april').toString(),
            this.$t('enum.month.may').toString(),
            this.$t('enum.month.june').toString(),
            this.$t('enum.month.july').toString(),
            this.$t('enum.month.august').toString(),
            this.$t('enum.month.september').toString(),
            this.$t('enum.month.october').toString(),
            this.$t('enum.month.november').toString(),
            this.$t('enum.month.december').toString(),
        ];
        this.local.dayNames = [
            this.$t('enum.weekDay.sunday').toString(),
            this.$t('enum.weekDay.monday').toString(),
            this.$t('enum.weekDay.tuesday').toString(),
            this.$t('enum.weekDay.wednesday').toString(),
            this.$t('enum.weekDay.thursday').toString(),
            this.$t('enum.weekDay.friday').toString(),
            this.$t('enum.weekDay.saturday').toString(),
        ];

        await this.modelValueChange(this.value as any as Date);
    }

    @Watch('value')
    async modelValueChange(newValue: Date | string) {
        if (typeof newValue === 'string') {
            this.local.value = new Date(newValue);
            this.local.date = new Date(newValue);
            this.local.time = new Date(newValue);
        } else {
            if (newValue) {
                this.local.value = newValue;
                this.local.date = new Date(newValue);
                this.local.time = new Date(newValue);
            } else {
                this.local.value = newValue;
                this.local.date = undefined;
                this.local.time = undefined;
            }
        }
    }

    @Watch('local.date')
    async inputDateChange(date: Date) {
        if (date) {
            this.$emit('input', dateAndTimeToDbDateTimeString(date, this.local.time!!));
        } else {
            this.$emit('input', undefined);
        }
    }

    @Watch('local.time')
    async inputTimeChange(time: Date) {
        if (this.local.date) {
            this.$emit('input', dateAndTimeToDbDateTimeString(this.local.date!!, time));
        } else {
            this.$emit('input', undefined);
        }
    }

    formatDate(date: string) {
        if (!date) {
            return '';
        }
        return dateToUiDateTimeString(new Date(date));
    }

    getFieldName() {
        return getFieldNameFromVModelProperty(this);
    }

    dateToString(date: Date) {
        if (!date) {
            return '';
        }
        return dateToDbDateString(date);
    }
}
